import { Customer, VehicleRec, ascClickToCallInput, ascCommSubmissionSvcInput, ascCtaInteractionInput, ascFormEngagementInput, ascFormSubmissionInput, ascFormSubmissionSvcApptInput, ascFormSubmissionSvcInput, ascLoginInput, ascMediaInteractionInput, ascMenuInteractionInput, ascPageviewInput, ascRetailProcessInput, ascElementConfigurationInput  } from "src/models";
import TagManager from "react-gtm-module";
import * as Sentry from '@sentry/react';

declare global {
    interface Window {
        utag?: Utag;
        productName?: string;
    }
}

interface Utag {
    link: (data: object) => void;
    view: (data: object) => void;
    data: UtagData;
    v_id: string;
}

interface UtagData {
    tealium_visitor_id: string;
}

export function ascCtaInteraction (input: ascCtaInteractionInput, e: any, itemList?: VehicleRec[], selectItem?: string) {
    const isCookiesEnabled = navigator.cookieEnabled;
    if (isCookiesEnabled) {
        let vehicle: VehicleRec | undefined = undefined
        if (itemList) {
            if (itemList.length === 1) {
                vehicle = itemList[0];
            } else if (selectItem) {
                vehicle = itemList[selectItem];
            }
        }
        if (!input.eventOwner) {
            input.eventOwner = 'reynolds_and_reynolds';
        }

        const elementColor = getElementColor(e, 'bgColor');
        let eventAction = input.eventAction;
        if (e?.charCode !== undefined) {
            switch (e.charCode){
                case 13:
                    eventAction = 'key_press_enter';
                    break;
                case 0:
                    eventAction = 'close'
                    break;
                default:
                    eventAction = 'click';
            }
        }
        const eventInp = {
            event_owner: input.eventOwner,
            page_type: input.pageType,
            element_text: input.elementText,
            element_color: input.elementColor ? input.elementColor : elementColor,
            element_order: input.elementOrder,
            element_type: input.elementType,
            element_subtype: input.elementSubType,
            event_action: eventAction,
            event_action_result: input.eventActionResult,
            link_url: input.linkUrl,
            item_id: vehicle?.vin ?? '',
            item_number: '',
            item_price: '',
            item_condition: 'used',
            item_year: vehicle?.year ?? '',
            item_make: vehicle?.make ?? '',
            item_model: vehicle?.model,
            item_variant: vehicle?.style ?? '',
            item_color: vehicle?.color ?? '',
            item_type: '',
            item_category: '',
            item_fuel_type: '',
            item_inventory_date: '',
            product_name: window.productName,
            affiliation: 'Reynolds and Reynolds',
        }
        const eventInpGA4 = {
            event: 'asc_cta_interaction',
            ...eventInp,
        }
        const eventInpTealium = {
            tealium_event: 'asc_cta_interaction',
            ...eventInp,
        }
        // window['asc_datalayer']?.events?.push({...eventInp});
        try {
            TagManager.dataLayer({dataLayer: {...eventInpGA4}, dataLayerName: 'asc_datalayer'});
            window.utag?.link({...eventInpTealium});
        } catch (e) {
            Sentry.captureException(e);
        }
    }
}

export function ascFormEngagement (input: ascFormEngagementInput, itemList?: VehicleRec[], selectItem?: string) {
    const isCookiesEnabled = navigator.cookieEnabled;
    if (isCookiesEnabled) {
        let vehicle: VehicleRec | undefined = undefined
        if (itemList) {
            if (itemList.length === 1) {
                vehicle = itemList[0];
            } else if (selectItem) {
                vehicle = itemList[selectItem];
            }
        }
        if (!input.eventOwner) {
            input.eventOwner = 'reynolds_and_reynolds';
        }
        const eventInp = {
            event_owner: input.eventOwner,
            page_type: input.pageType,
            comm_type: input.commType,
            comm_status: input.commStatus,
            element_text: input.elementText,
            department: input.department,
            form_name: input.formName,
            form_type: input.formType,
            item_id: vehicle?.vin,
            item_number: '',
            item_price: '',
            item_condition: 'used',
            item_year: vehicle?.year ?? '',
            item_make: vehicle?.make ?? '',
            item_model: vehicle?.model ?? '',
            item_variant: vehicle?.style ?? '',
            item_color: vehicle?.color ?? '',
            item_type: '',
            item_category: '',
            item_fuel_type: '',
            item_inventory_date: '',
            product_name: window.productName,
        }
        const eventInpGA4 = {
            event: 'asc_form_engagement',
            ...eventInp,
        }
        const eventInpTealium = {
            tealium_event: 'asc_form_engagement',
            ...eventInp,
        }
        // window['asc_datalayer']?.events?.push({...eventInp});
        try {
            TagManager.dataLayer({dataLayer: {...eventInpGA4}, dataLayerName: 'asc_datalayer'});
            window.utag?.link({...eventInpTealium});
        } catch (e) {
            Sentry.captureException(e);
        }
    }
}

export function ascMediaInteraction (input: ascMediaInteractionInput, itemList?: VehicleRec[], selectItem?: string) {
    const isCookiesEnabled = navigator.cookieEnabled;
    if (isCookiesEnabled) {
        let vehicle: VehicleRec | undefined = undefined
        if (itemList) {
            if (itemList.length === 1) {
                vehicle = itemList[0];
            } else if (selectItem) {
                vehicle = itemList[selectItem];
            }
        }
        if (!input.eventOwner) {
            input.eventOwner = 'reynolds_and_reynolds';
        }
        const eventInp = {
            event_owner: input.eventOwner,
            page_type: input.pageType,
            event_action_result: input.eventActionResult,
            affiliation: input.affiliation,
            media_type: input.mediaType,
            link_url: input.linkUrl,
            creative_name: input.creativeName,
            item_id: vehicle?.vin,
            item_number: '',
            item_price: '',
            item_condition: 'used',
            item_year: vehicle?.year ?? '',
            item_make: vehicle?.make ?? '',
            item_model: vehicle?.model ?? '',
            item_variant: vehicle?.style ?? '',
            item_color: vehicle?.color ?? '',
            item_type: '',
            item_category: '',
            item_fuel_type: '',
            item_inventory_date: '',
            product_name: window.productName,
        }
        const eventInpGA4 = {
            event: 'asc_media_interaction',
            ...eventInp,
        }
        const eventInpTealium = {
            tealium_event: 'asc_media_interaction',
            ...eventInp,
        }
        // window['asc_datalayer']?.events?.push({...eventInp});
        // TagManager.dataLayer({dataLayer: {events: {...eventInp}}, dataLayerName: 'asc_datalayer'});
        try {
            TagManager.dataLayer({dataLayer: {...eventInpGA4}, dataLayerName: 'asc_datalayer'});
            window.utag?.link({...eventInpTealium});
        } catch (e) {
            Sentry.captureException(e);
        }
    }
}

export function ascMenuInteraction (input: ascMenuInteractionInput) {
    const isCookiesEnabled = navigator.cookieEnabled;
    if (isCookiesEnabled) {
        if (!input.eventOwner) {
            input.eventOwner = 'reynolds_and_reynolds';
        }
        const eventInp = {
            event_owner: input.eventOwner,
            page_type: input.pageType,
            element_text: input.elementText,
            element_subtype: input.elementSubtype,
            element_type: input.elementType,
            event_action: input.eventAction,
            product_name: window.productName,
        }
        const eventInpGA4 = {
            event: 'asc_menu_interaction',
            ...eventInp,
        }
        const eventInpTealium = {
            tealium_event: 'asc_menu_interaction',
            ...eventInp,
        }
        // window['asc_datalayer']?.events?.push({...eventInp});
        try {
            TagManager.dataLayer({dataLayer: {...eventInpGA4}, dataLayerName: 'asc_datalayer'});
            window.utag?.link({...eventInpTealium});
        } catch (e) {
            Sentry.captureException(e);
        }
    }
}

export function ascPageview (input: ascPageviewInput, itemList?: VehicleRec[], selectItem?: string) {
    const isCookiesEnabled = navigator.cookieEnabled;
    if (isCookiesEnabled) {
        let vehicle: VehicleRec | undefined = undefined
        if (itemList) {
            if (itemList.length === 1) {
                vehicle = itemList[0];
            } else if (selectItem) {
                vehicle = itemList[selectItem];
            }
        }
        if (!input.eventOwner) {
            input.eventOwner = 'reynolds_and_reynolds';
        }
        const eventInp = {
            event_owner: input.eventOwner,
            page_type: input.pageType,
            error_code: input.errorCode,
            item_id: vehicle?.vin,
            item_number: '',
            item_price: '',
            item_condition: 'used',
            item_year: vehicle?.year ?? '',
            item_make: vehicle?.make ?? '',
            item_model: vehicle?.model ?? '',
            item_variant: vehicle?.style ?? '',
            item_color: vehicle?.color ?? '',
            item_type: '',
            item_category: '',
            item_fuel_type: '',
            item_inventory_date: '',
            item_results: input.itemResults,
            product_name: window.productName,
        }
        const eventInpGA4 = {
            event: 'asc_pageview',
            ...eventInp,
        }
        const eventInpTealium = {
            tealium_event: 'asc_pageview',
            ...eventInp,
        }
        // window['asc_datalayer']?.events?.push({...eventInp});
        // TagManager.dataLayer({dataLayer: {events: {...eventInp}}, dataLayerName: 'asc_datalayer'});
        try {
            TagManager.dataLayer({dataLayer: {...eventInpGA4}, dataLayerName: 'asc_datalayer'});
            window.utag?.view({...eventInpTealium});
        } catch (e) {
            Sentry.captureException(e);
        }
    }
}

export function ascFormSubmission (input: ascFormSubmissionInput, itemList?: VehicleRec[], selectItem?: string) {
    const isCookiesEnabled = navigator.cookieEnabled;
    if (isCookiesEnabled) {
        let vehicle: VehicleRec | undefined = undefined
        if (itemList) {
            if (itemList.length === 1) {
                vehicle = itemList[0];
            } else if (selectItem) {
                vehicle = itemList[selectItem];
            }
        }
        if (!input.eventOwner) {
            input.eventOwner = 'reynolds_and_reynolds';
        }
        const eventInp = {
            event_owner: input.eventOwner,
            page_type: input.pageType,
            comm_type: input.commType,
            comm_outcome: input.commOutcome,
            submission_id: input.submissionId,
            element_text: input.elementText,
            department: input.department,
            form_name: input.formName,
            form_type: input.formType,
            item_id: vehicle?.vin,
            item_number: '',
            item_price: '',
            item_condition: 'used',
            item_year: vehicle?.year ?? '',
            item_make: vehicle?.make ?? '',
            item_model: vehicle?.model ?? '',
            item_variant: vehicle?.style ?? '',
            item_color: vehicle?.color ?? '',
            item_type: '',
            item_category: '',
            item_fuel_type: '',
            item_inventory_date: '',
            product_name: window.productName,
        }
        const eventInpGA4 = {
            event: 'asc_form_submission',
            ...eventInp,
        }
        const eventInpTealium = {
            tealium_event: 'asc_form_submission',
            ...eventInp,
        }
        // window['asc_datalayer']?.events?.push({...eventInp});
        // TagManager.dataLayer({dataLayer: {events: {...eventInp}, dataLayerName: 'asc_datalayer'}});
        try {
            TagManager.dataLayer({dataLayer: {...eventInpGA4}, dataLayerName: 'asc_datalayer'});
            window.utag?.link({...eventInpTealium});
        } catch (e) {
            Sentry.captureException(e);
        }
    }
}

export function ascFormSubmissionSvc (input: ascFormSubmissionSvcInput, itemList?: VehicleRec[], selectItem?: string) {
    const isCookiesEnabled = navigator.cookieEnabled;
    if (isCookiesEnabled) {
        let vehicle: VehicleRec | undefined = undefined
        if (itemList) {
            if (itemList.length === 1) {
                vehicle = itemList[0];
            } else if (selectItem) {
                vehicle = itemList[selectItem];
            }
        }
        if (!input.eventOwner) {
            input.eventOwner = 'reynolds_and_reynolds';
        }
        const eventInp = {
            event_owner: input.eventOwner,
            page_type: input.pageType,
            comm_type: input.commType,
            comm_outcome: input.commOutcome,
            submission_id: input.submissionId,
            element_text: input.elementText,
            department: input.department,
            form_name: input.formName,
            form_type: input.formType,
            item_id: vehicle?.vin,
            item_number: '',
            item_price: '',
            item_condition: 'used',
            item_year: vehicle?.year ?? '',
            item_make: vehicle?.make ?? '',
            item_model: vehicle?.model ?? '',
            item_variant: vehicle?.style ?? '',
            item_color: vehicle?.color ?? '',
            item_type: '',
            item_category: '',
            item_fuel_type: '',
            item_inventory_date: '',
            product_name: window.productName,
        }
        const eventInpGA4 = {
            event: 'asc_form_submission_service',
            ...eventInp,
        }
        const eventInpTealium = {
            tealium_event: 'asc_form_submission_service',
            ...eventInp,
        }
        // window['asc_datalayer']?.events?.push({...eventInp});
        // TagManager.dataLayer({dataLayer: {events: {...eventInp}}, dataLayerName: 'asc_datalayer'});
        try {
            TagManager.dataLayer({dataLayer: {...eventInpGA4}, dataLayerName: 'asc_datalayer'});
            window.utag?.link({...eventInpTealium});
        } catch (e) {
            Sentry.captureException(e);
        }
    }
}

export function ascFormSubmissionSvcAppt (input: ascFormSubmissionSvcApptInput, itemList?: VehicleRec[], selectItem?: string) {
    const isCookiesEnabled = navigator.cookieEnabled;
    if (isCookiesEnabled) {
        let vehicle: VehicleRec | undefined = undefined
        if (itemList) {
            if (itemList.length === 1) {
                vehicle = itemList[0];
            } else if (selectItem) {
                vehicle = itemList[selectItem];
            }
        }
        if (!input.eventOwner) {
            input.eventOwner = 'reynolds_and_reynolds';
        }
        const eventInp = {
            event_owner: input.eventOwner,
            page_type: input.pageType,
            comm_type: input.commType,
            comm_outcome: input.commOutcome,
            submission_id: input.submissionId,
            element_text: input.elementText,
            department: input.department,
            form_name: input.formName,
            form_type: input.formType,
            item_id: vehicle?.vin,
            item_number: '',
            item_price: '',
            item_condition: 'used',
            item_year: vehicle?.year ?? '',
            item_make: vehicle?.make ?? '',
            item_model: vehicle?.model ?? '',
            item_variant: vehicle?.style ?? '',
            item_color: vehicle?.color ?? '',
            item_type: '',
            item_category: '',
            item_fuel_type: '',
            item_inventory_date: '',
            product_name: window.productName,
        }
        const eventInpGA4 = {
            event: 'asc_form_submission_service_appt',
            ...eventInp,
        }
        const eventInpTealium = {
            tealium_event: 'asc_form_submission_service_appt',
            ...eventInp,
        }
        // window['asc_datalayer']?.events?.push({...eventInp});
        // TagManager.dataLayer({dataLayer: {events: {...eventInp}}, dataLayerName: 'asc_datalayer'});
        try {
            TagManager.dataLayer({dataLayer: {...eventInpGA4}, dataLayerName: 'asc_datalayer'});
            window.utag?.link({...eventInpTealium});
        } catch (e) {
            Sentry.captureException(e);
        }
    }
}

export function ascLogin (input: ascLoginInput, itemList?: VehicleRec[], selectItem?: string) {
    const isCookiesEnabled = navigator.cookieEnabled;
    if (isCookiesEnabled) {
        let vehicle: VehicleRec | undefined = undefined
        if (itemList) {
            if (itemList.length === 1) {
                vehicle = itemList[0];
            } else if (selectItem) {
                vehicle = itemList[selectItem];
            }
        }
        if (!input.eventOwner) {
            input.eventOwner = 'reynolds_and_reynolds';
        }
        const eventInp = {
            element_text: input.elementText,
            element_type: input.elementType,
            event_action: input.eventAction,
            event_action_result: input.eventActionResult,
            event_name: 'asc_login',
            event_owner: input.eventOwner,
            page_type: input.pageType,
            item_id: vehicle?.vin ?? '',
            item_number: '',
            item_price: '',
            item_condition: 'used',
            item_year: vehicle?.year ?? '',
            item_make: vehicle?.make ?? '',
            item_model: vehicle?.model,
            item_variant: vehicle?.style ?? '',
            item_color: vehicle?.color ?? '',
            item_type: '',
            item_category: '',
            item_fuel_type: '',
            item_inventory_date: '',
            product_name: window.productName,
        }
        const eventInpGA4 = {
            event: 'asc_login',
            ...eventInp,
        }
        const eventInpTealium = {
            tealium_event: 'asc_login',
            ...eventInp,
        }
        // window['asc_datalayer']?.events?.push({...eventInp});
        // TagManager.dataLayer({dataLayer: {events: {...eventInp}}, dataLayerName: 'asc_datalayer'});
        try {
            TagManager.dataLayer({dataLayer: {...eventInpGA4}, dataLayerName: 'asc_datalayer'});
            window.utag?.link({...eventInpTealium});
        } catch (e) {
            Sentry.captureException(e);
        }
    }
}

export function ascClickToCall (input: ascClickToCallInput, itemList?: VehicleRec[], selectItem?: string) {
    const isCookiesEnabled = navigator.cookieEnabled;
    if (isCookiesEnabled) {
        let vehicle: VehicleRec | undefined = undefined
        if (itemList) {
            if (itemList.length === 1) {
                vehicle = itemList[0];
            } else if (selectItem) {
                vehicle = itemList[selectItem];
            }
        }
        if (!input.eventOwner) {
            input.eventOwner = 'reynolds_and_reynolds';
        }
        const eventInp = {
            event_owner: input.eventOwner,
            page_type: input.pageType,
            comm_phone_number: input.commPhoneNumber,
            department: input.department,
            affiliation: input.affiliation,
            item_id: vehicle?.vin,
            item_number: '',
            item_price: '',
            item_condition: 'used',
            item_year: vehicle?.year ?? '',
            item_make: vehicle?.make ?? '',
            item_model: vehicle?.model ?? '',
            item_variant: vehicle?.style ?? '',
            item_color: vehicle?.color ?? '',
            item_type: '',
            item_category: '',
            item_fuel_type: '',
            item_inventory_date: '',
            product_name: window.productName,
        }
        const eventInpGA4 = {
            event: 'asc_click_to_call',
            ...eventInp,
        }
        const eventInpTealium = {
            tealium_event: 'asc_click_to_call',
            ...eventInp,
        }
        // window['asc_datalayer']?.events?.push({...eventInp});
        // TagManager.dataLayer({dataLayer: {events: {...eventInp}}, dataLayerName: 'asc_datalayer'});
        try {
            TagManager.dataLayer({dataLayer: {...eventInpGA4}, dataLayerName: 'asc_datalayer'});
            window.utag?.link({...eventInpTealium});
        } catch (e) {
            Sentry.captureException(e);
        }
    }
}

export function ascCommSubmissionSvc (input: ascCommSubmissionSvcInput, itemList?: VehicleRec[], selectItem?: string) {
    const isCookiesEnabled = navigator.cookieEnabled;
    if (isCookiesEnabled) {
        let vehicle: VehicleRec | undefined = undefined
        if (itemList) {
            if (itemList.length === 1) {
                vehicle = itemList[0];
            } else if (selectItem) {
                vehicle = itemList[selectItem];
            }
        }
        if (!input.eventOwner) {
            input.eventOwner = 'reynolds_and_reynolds';
        }
        const eventInp = {
            event_owner: input.eventOwner,
            page_type: input.pageType,
            comm_type: input.commType,
            affiliation: input.affiliation,
            element_position: input.elementPosition,
            department: input.department,
            affiliation_id: input.affiliationId,
            comm_status: input.commStatus,
            item_id: vehicle?.vin,
            item_number: '',
            item_price: '',
            item_condition: 'used',
            item_year: vehicle?.year ?? '',
            item_make: vehicle?.make ?? '',
            item_model: vehicle?.model ?? '',
            item_variant: vehicle?.style ?? '',
            item_color: vehicle?.color ?? '',
            item_type: '',
            item_category: '',
            item_fuel_type: '',
            item_inventory_date: '',
            product_name: window.productName,
        }
        const eventInpGA4 = {
            event: 'asc_comm_submission_service',
            ...eventInp,
        }
        const eventInpTealium = {
            tealium_event: 'asc_comm_submission_service',
            ...eventInp,
        }
        // window['asc_datalayer']?.events?.push({...eventInp});
        // TagManager.dataLayer({dataLayer: {events: {...eventInp}}, dataLayerName: 'asc_datalayer'});
        try {
            TagManager.dataLayer({dataLayer: {...eventInpGA4}, dataLayerName: 'asc_datalayer'});
            window.utag?.link({...eventInpTealium});
        } catch (e) {
            Sentry.captureException(e);
        }
    }
}

export function ascRetailProcess (input: ascRetailProcessInput, itemList?: VehicleRec[], selectItem?: string ) {
    const isCookiesEnabled = navigator.cookieEnabled;
    if (isCookiesEnabled) {
        let vehicle: VehicleRec | undefined = undefined
        if (itemList) {
            if (itemList.length === 1) {
                vehicle = itemList[0];
            } else if (selectItem) {
                vehicle = itemList[selectItem];
            }
        }
        if (!input.eventOwner) {
            input.eventOwner = 'reynolds_and_reynolds';
        }
        const eventInp = {
            event_owner: input.eventOwner,
            page_type: input.pageType,
            flow_name: input.flowName,
            element_title: input.elementTitle,
            flow_outcome: input.flowOutcome,
            item_payment: '',
            flow_stage: input.flowStage,
            item_id: vehicle?.vin,
            item_number: '',
            item_price: '',
            item_condition: 'used',
            item_year: vehicle?.year ?? '',
            item_make: vehicle?.make ?? '',
            item_model: vehicle?.model ?? '',
            item_variant: vehicle?.style ?? '',
            item_color: vehicle?.color ?? '',
            item_type: '',
            item_category: '',
            item_fuel_type: '',
            item_inventory_date: '',
            product_name: window.productName,
        }
        const eventInpGA4 = {
            event: 'asc_retail_process',
            ...eventInp,
        }
        const eventInpTealium = {
            tealium_event: 'asc_retail_process',
            ...eventInp,
        }
        TagManager.dataLayer({dataLayer: {...eventInpGA4}, dataLayerName: 'asc_datalayer'});
        window.utag?.link({...eventInpTealium});
    }
}

export function ascElementConfiguration (input: ascElementConfigurationInput, e: any, itemList?: VehicleRec[], selectItem?: string) {
    const isCookiesEnabled = navigator.cookieEnabled;
    if (isCookiesEnabled) {
        let vehicle: VehicleRec | undefined = undefined
        if (itemList) {
            if (itemList.length === 1) {
                vehicle = itemList[0];
            } else if (selectItem) {
                vehicle = itemList[selectItem];
            }
        }
        if (!input.eventOwner) {
            input.eventOwner = 'reynolds_and_reynolds';
        }
        const elementColor = getElementColor(e, 'bgColor');
        const eventInp = {
            event_owner: input.eventOwner,
            page_type: input.pageType,
            elementText: input.elementText,
            elementColor: input.elementColor ? input.elementColor : elementColor,
            elementType: input.elementType,
            event_action: input.eventAction,
            event_action_result: input.eventActionResult,
            item_category: '',
            item_color: vehicle?.color ?? '',
            item_model: vehicle?.model ?? '',
            item_number: '',
            item_condition: 'used',
            item_variant: vehicle?.style ?? '',
            link_url: input.linkUrl,
            product_name: window.productName,
        }
        const eventInpGA4 = {
            event: 'asc_element_configuration',
            ...eventInp,
        }
        const eventInpTealium = {
            tealium_event: 'asc_element_configuration',
            ...eventInp,
        }
        TagManager.dataLayer({dataLayer: {...eventInpGA4}, dataLayerName: 'asc_datalayer'});
        window.utag?.link({...eventInpTealium});
    }
}

export function utagIdentityLink (input: Customer) {
    const identityLink = {
        tealium_event: 'identity_event',
        customer_email: input.encryptEmail ? input.encryptEmail : input.emailAddress,
        customer_phone: input.encryptPhone ? input.encryptPhone : input.phoneNumber,
        customer_first_name: input.encryptFirst ? input.encryptFirst : input.firstName,
        customer_last_name: input.encryptLast ? input.encryptLast : input.lastName,
        text_opt_in: input.textOptIn === 'I' || input.textOptIn === 'D' ? true : false,
    };
    window.utag?.link({...identityLink});
}

export function getUtagEnv () {
    const utagEnv = process.env.REACT_APP_UTAG_ENV ?? '';
    return utagEnv;
}

export function getElementColor(e: any, type: 'bgColor' | 'color' | 'fill') {
    let elementColor = '';
    let element: any = '';
    if (typeof(e) === 'string') {
        element = document.getElementById(e);
    } else {
        element = e?.target;
    }
    if (element) {
        switch (type) {
            case 'bgColor':
                elementColor = window.getComputedStyle(element).backgroundColor;
                break;
            case 'color':
                elementColor = window.getComputedStyle(element).color;
                break;
            case 'fill':
                elementColor = window.getComputedStyle(element).fill;
                break;
            default:
                elementColor = window.getComputedStyle(element).backgroundColor;
        }
        if (elementColor.trim() === 'rgba(0, 0, 0, 0)') {
            switch (type) {
                case 'bgColor':
                    elementColor = window.getComputedStyle(element.parentNode).backgroundColor;
                    break;
                case 'color':
                    elementColor = window.getComputedStyle(element.parentNode).color;
                    break;
                case 'fill':
                    elementColor = window.getComputedStyle(element.parentNode).fill;
                    break;
                default:
                    elementColor = window.getComputedStyle(element.parentNode).backgroundColor;
            }
        }
        if (elementColor.trim() === 'rgba(0, 0, 0, 0)') {
            switch (type) {
                case 'bgColor':
                    elementColor = window.getComputedStyle(element.parentNode.parentNode).backgroundColor;
                    break;
                case 'color':
                    elementColor = window.getComputedStyle(element.parentNode.parentNode).color;
                    break;
                case 'fill':
                    elementColor = window.getComputedStyle(element.parentNode.parentNode).fill;
                    break;
                default:
                    elementColor = window.getComputedStyle(element.parentNode.parentNode).backgroundColor;
            }
        }
    }
    if (elementColor) {
        let colorSpace = elementColor.split('(')[1];
        colorSpace = colorSpace.split(')')[0]
        const colorArr = colorSpace.split(',');
        if (colorArr?.length === 4) {
            if (colorArr[3].trim() === '0') {
                elementColor = '';
            } else {
                const colorArrInt = colorArr.map(color => parseInt(color.trim()));
                elementColor = '#';
                for (let i = 0; i < 3; i++) {
                    if (colorArrInt[i].toString(16).length === 1) {
                        elementColor = elementColor + '0' + colorArrInt[i].toString(16);
                    } else if (colorArrInt[i].toString(16).length === 2) {
                        elementColor = elementColor + colorArrInt[i].toString(16);
                    }
                }
            }
        } else {
            if(colorArr) {
                const colorArrInt = colorArr.map(color => parseInt(color.trim()));
                elementColor ='#';
                for (let i = 0; i < colorArrInt.length; i++) {
                    if (colorArrInt[i].toString(16).length === 1) {
                        elementColor = elementColor + '0' + colorArrInt[i].toString(16);
                    } else if (colorArrInt[i].toString(16).length === 2) {
                        elementColor = elementColor + colorArrInt[i].toString(16);
                    }
                }
            }
        }
    }
    return elementColor;
}

export function setProductName (productName: string) {
    window.productName = productName + ' Service Portal';
    return (window.productName)
}